import cx from 'classnames'
import React from 'react'

import { activateNextPane } from '../../actions/play-actions'
import { Pane, PaneClasses } from '../../constants/constants'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { selectIsFocus } from '../../reducers/focusSlice'
import { selectIsLandscape } from '../../selectors/session-selectors'
import { PlayActions } from '../../types'
import { isMobile as getIsMobile } from '../../util/track-utils'
import BlastButton from './BlastButton'
import PlayControls from './PlayControls'
import { selectCurrentActiveGamers } from '../../selectors/current-play-selectors'

type Props = {
  playActions: PlayActions
}
const BottomContainer = ({ playActions }: Props) => {
  const isMobile = getIsMobile()
  const dispatch = useAppDispatch()
  const isCurrFocus = useAppSelector(selectIsFocus(Pane.PLAY_CONTROLS))
  const isLandscape = useAppSelector(selectIsLandscape)
  const activeGamers = useAppSelector(selectCurrentActiveGamers)
  const playerNames = activeGamers.map(({ playerName, gamerId }) =>
    playerName ? playerName : gamerId
  )
  const buttonPlayerNames = activeGamers.length === 2 ? [playerNames[0], playerNames[1]] : ['', '']

  const className = cx(PaneClasses[Pane.PLAY_CONTROLS], {
    hasFocus: isCurrFocus,
  })
  const onClick = () => {
    // console.log(`container: ${PaneClasses[Pane.PLAY_CONTROLS]}`)
    dispatch(activateNextPane({ pane: Pane.PLAY_CONTROLS }))
  }
  const blastAreaClassName = cx('blastArea', { portrait: isMobile && !isLandscape })
  return (
    <div className={className} onClick={onClick}>
      <div className={blastAreaClassName}>
        <BlastButton isRight={false} playerName={buttonPlayerNames[0]} />
        {(!isMobile || isLandscape) && <PlayControls playActions={playActions} />}
        <BlastButton isRight playerName={buttonPlayerNames[1]} />
      </div>
    </div>
  )
}

export default BottomContainer
